import type { Result } from '@de/types/result';

/**
 * Prefer the Offerings UUID used by `GET /v1/offerings/:id`. Fall back to
 * `offeringId` when authors/host still store the UUID there.
 */
export function resolveOfferingIdForDetail(
  result: Pick<Result, 'offeringUuid' | 'offeringId'>,
): string | undefined {
  const uuid = result.offeringUuid?.trim();
  if (uuid) return uuid;
  const offeringId = result.offeringId?.trim();
  if (offeringId) return offeringId;
  return undefined;
}

/**
 * True when a compared program still needs a detail-by-id fetch to populate
 * TCPA (and sibling drawer-detail fields). Legacy results that already carry
 * `tcpa` skip the network hop.
 */
export function needsComparisonDetailHydration(
  result: Pick<Result, 'tcpa' | 'offeringUuid' | 'offeringId'>,
): boolean {
  if (result.tcpa?.trim()) {
    return false;
  }
  return Boolean(resolveOfferingIdForDetail(result));
}
